<template>
  <v-col cols="6" center>
    <v-form @keyup.native.enter="login">
      <v-card-text>
        <v-text-field
          :label="$t('login.email')"
          v-model="email"
          prepend-icon="mdi-account"
          :error="loginError"
          type="text"
        >
        </v-text-field>

        <v-text-field
          :label="$t('login.password')"
          v-model="password"
          prepend-icon="mdi-lock"
          :error="loginError"
          :error-messages="loginErrorMessages"
          type="password"
        >
        </v-text-field>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="primary" @click="login">Login</v-btn>
      </v-card-actions>
    </v-form>
  </v-col>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      loginError: false,
      loginErrorMessages: [],
    };
  },
  methods: {
    login() {
      var redirect = this.$auth.redirect();
      var app = this;
      this.$auth.login({
        params: {
          email: this.email,
          password: this.password,
        },
        success: function () {
          this.$router.push({ name: "Home" }).catch((err) => {});
        },
        error: function () {
          this.loginError = true;
          this.loginErrorMessages = [this.$t("login.error.credential")];
        },
        rememberMe: true,
        fetchUser: true,
      });
    },
  },
};
</script>

<style scoped>
</style>
